import { useState } from 'react'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { InputText } from '#app/components/ui/input-text'

interface ARTPersonalDataScreenProps {
	onNext: (data: {
		nombreApellido: string
		email: string
		telefono: string
	}) => void
	onBack: () => void
	data?: {
		nombreApellido?: string
		email?: string
		telefono?: string
	}
}

export function ARTPersonalDataScreen({
	onNext,
	onBack,
	data,
}: ARTPersonalDataScreenProps) {
	const [formData, setFormData] = useState({
		nombreApellido: data?.nombreApellido || '',
		email: data?.email || '',
		telefono: data?.telefono || '',
	})

	const [errors, setErrors] = useState<Record<string, string>>({})

	const validateEmail = (email: string) => {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
		return regex.test(email)
	}

	const handleSubmit = () => {
		const newErrors: Record<string, string> = {}

		if (!formData.nombreApellido.trim()) {
			newErrors.nombreApellido = 'Ingresa tu nombre y apellido'
		}

		if (!formData.email.trim()) {
			newErrors.email = 'Ingresa tu email'
		} else if (!validateEmail(formData.email)) {
			newErrors.email = 'Ingresa un email válido'
		}

		if (!formData.telefono.trim()) {
			newErrors.telefono = 'Ingresa tu teléfono'
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors)
			return
		}

		onNext(formData)
	}

	const isFormValid =
		formData.nombreApellido.trim() &&
		formData.email.trim() &&
		formData.telefono.trim()

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-8">
					<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800">
						Por último, tus datos personales
					</h2>

					{/* Form inputs */}
					<div className="flex w-full flex-col gap-6">
						<InputText
							label="Nombre apellido"
							labelPosition="internal"
							size="l"
							placeholder="Nombre apellido"
							value={formData.nombreApellido}
							onChange={(e) => {
								setFormData({ ...formData, nombreApellido: e.target.value })
								setErrors({ ...errors, nombreApellido: '' })
							}}
							errorText={errors.nombreApellido}
							required
						/>
						<InputText
							label="Email"
							labelPosition="internal"
							size="l"
							type="email"
							placeholder="Email"
							value={formData.email}
							onChange={(e) => {
								setFormData({ ...formData, email: e.target.value })
								setErrors({ ...errors, email: '' })
							}}
							errorText={errors.email}
							required
						/>
						<InputText
							label="Teléfono"
							labelPosition="internal"
							size="l"
							type="tel"
							placeholder="Teléfono"
							value={formData.telefono}
							onChange={(e) => {
								setFormData({ ...formData, telefono: e.target.value })
								setErrors({ ...errors, telefono: '' })
							}}
							errorText={errors.telefono}
							required
						/>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Atrás
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={handleSubmit}
					disabled={!isFormValid}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Siguiente
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
